class WLSProductListing extends HTMLElement {
    constructor() {
        super();
        this.collectionPicker = this.querySelector('.js-collection-picker');
        this.collectionPickers = this.querySelectorAll('.js-collection-picker-link');
        this.productGrid = this.querySelector('.js-product-grid');
        this.applyFilters = this.querySelector('.js-apply-filters');
        this.availabilityFilters = this.querySelectorAll('.js-filter-checkbox');
        this.typeFilters = this.querySelectorAll('.js-filter-checkbox-type');
        this.filtersAccordions = this.querySelectorAll('.js-aside-accordion');
        this.priceFiltersMin = this.querySelector('.js-price-input-min');
        this.priceFiltersMax = this.querySelector('.js-price-input-max');
        this.sortBy = this.querySelector('.js-sort-by');
        this.noProducts = this.querySelector('.js-no-products');
        this.clearFilters = this.querySelector('.js-clear-filters');
        this.asideMenuTrigger = this.querySelector('.js-aside-filters-menu-trigger');
        this.asideMenu = this.querySelector('.js-aside-menu-filters');
        this.asideMenuClose = this.querySelector('.js-aside-menu-close');
        this.asideMenuOverlay = this.querySelector('.js-aside-overlay');
        this.filters = this.querySelector('.wls-product-listing__aside-filters');
    }

    connectedCallback() {
        this.bindEvents();
        this.initFilters();
        this.handleFilterAccordions();
        this.asideMenuFunctionality();
        this.initElements();
    }

    bindEvents() {
        this.collectionPickers.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                this.handleClick(item);
            });
        });

        this.applyFilters.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleApplyFilters();
        });

        this.clearFilters.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleClearFilters();
        });

        this.sortBy.addEventListener('change', (e) => {
            e.preventDefault();
            this.handleSortByChange();
        });
    }

    handleClearFilters() {
        const params = new URLSearchParams(window.location.search);

        const keys = [...params.keys()];

        keys.forEach(key => params.delete(key));

        const baseUrl = window.location.origin + window.location.pathname;
        const newUrl = baseUrl;

        window.history.replaceState(null, '', newUrl);
        this.loadProductGrid(newUrl);
        this.clearFiltersInputs();
    }

    handleSortByChange() {
        const sortBy = this.sortBy.value;
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', sortBy);

        const baseUrl = window.location.origin + window.location.pathname;
        const newUrl = baseUrl + '?' + params.toString();

        window.history.replaceState(null, '', newUrl);
        this.loadProductGrid(newUrl);
    }

    initFilters() {
        const params = new URLSearchParams(window.location.search);

        params.forEach((value, key) => {
            // Traži inpute po name atributu koji odgovara key-ju
            const input = document.querySelector(`[name="${key}"]`);
            if (!input) return;

            if (input.type === 'checkbox' || input.type === 'radio') {
                input.checked = value === input.value || value === '1';
            } else {
                input.value = value;
            }
        });
    }


    clearFiltersInputs() {
        this.availabilityFilters.forEach(item => {
            item.checked = false;
        });

        this.typeFilters.forEach(item => {
            item.checked = false;
        });

        this.priceFiltersMin.value = '';
        this.priceFiltersMax.value = '';
        this.sortBy.value = 'manual';
    }

    handleApplyFilters() {
        const availabilityFilters = Array.from(this.availabilityFilters).find(item => item.checked);
        const priceFiltersMin = this.priceFiltersMin.value;
        const priceFiltersMax = this.priceFiltersMax.value;
        const typeFilters = Array.from(this.typeFilters).filter(item => item.checked); // svi čekirani
    
        const params = new URLSearchParams();
    
        if (availabilityFilters?.value)
            params.set('filter.v.availability', availabilityFilters.value);
    
        if (priceFiltersMin)
            params.set('filter.v.price.gte', priceFiltersMin);
    
        if (priceFiltersMax)
            params.set('filter.v.price.lte', priceFiltersMax);
    
        typeFilters.forEach(item => {
            params.append('filter.p.m.wls.types_filter', item.value);
        });
    
        params.set('sort_by', this.sortBy.value);
    
        const queryString = '?' + params.toString();
        const baseUrl = window.location.origin + window.location.pathname;
        const newUrl = baseUrl + queryString;
    
        window.history.replaceState(null, '', newUrl);
        this.loadProductGrid(newUrl);
    }

    handleClick(item) {
        this.collectionPickers.forEach(item => {
            item.classList.remove('active');
        });

        item.classList.add('active');

        const url = item.dataset.url;
        history.pushState(null, '', url);
        this.loadProductGrid(url, true);
    }

    handleFilterAccordions() {
        if (this.filtersAccordions.length > 0) {
            this.filtersAccordions.forEach(acc => {
                acc.querySelector('.wls-product-listing__aside-filters-header').addEventListener('click', () => {
                    acc.classList.toggle('open');
                })
            })
        }
    }

    asideMenuFunctionality() {
        if (!this.asideMenuTrigger) return;
        this.asideMenuTrigger.addEventListener('click', () => {
            if (this.asideMenu) {
                this.asideMenu.classList.add('active');
                this.asideMenuOverlay.classList.add('visible');
                document.body.style.overflow = 'hidden';
            }
        })

        if (this.asideMenuClose) {
            this.asideMenuClose.addEventListener('click', () => {
                this.asideMenu.classList.remove('active');
                this.asideMenuOverlay.classList.remove('visible');
                document.body.style.overflow = 'visible';
            })
        }

        if (this.applyFilters) {
            this.applyFilters.addEventListener('click', () => {
                this.asideMenu.classList.remove('active');
                this.asideMenuOverlay.classList.remove('visible');
                document.body.style.overflow = 'visible';
            })
        }

        if (this.asideMenuOverlay) {
            this.asideMenuOverlay.addEventListener('click', () => {
                this.asideMenu.classList.remove('active');
                this.asideMenuOverlay.classList.remove('visible');
                document.body.style.overflow = 'visible';
            })
        }
    }

    initElements() {
        this.applyFilters = this.filters.querySelector('.js-apply-filters');
        this.clearFilters = this.filters.querySelector('.js-clear-filters');
        this.availabilityFilters = this.filters.querySelectorAll('.js-filter-checkbox');
        this.typeFilters = this.filters.querySelectorAll('.js-filter-checkbox-type');
        this.priceFiltersMin = this.filters.querySelector('.js-price-input-min');
        this.priceFiltersMax = this.filters.querySelector('.js-price-input-max');
        this.filtersAccordions = this.filters.querySelectorAll('.js-aside-accordion');
    }

    loadProductGrid(url, refreshFilters = false) {
        fetch(url)
            .then(res => {
                if (!res.ok) throw new Error('Fetch failed');
                return res.text();
            })
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newGrid = doc.querySelector('.js-product-grid');
                this.productGrid = this.querySelector('.js-product-grid');

                const heroSection = doc.querySelector('.wls-hero-text-centered');
                const currentHero = document.querySelector('.wls-hero-text-centered');

                const newFilters = doc.querySelector('.wls-product-listing__aside-filters');
                
                if (currentHero && heroSection) {
                    currentHero.innerHTML = heroSection.innerHTML;
                }

                if (newFilters && this.filters && refreshFilters) {
                    this.filters.innerHTML = newFilters.innerHTML;
                    this.initElements();
                    this.asideMenuFunctionality();
                    this.handleFilterAccordions();
                    
                    this.applyFilters.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.handleApplyFilters();
                    });

                    this.clearFilters.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.handleClearFilters();
                    });
                }

                if (newGrid && this.productGrid) {
                    this.productGrid.innerHTML = newGrid.innerHTML;
                    this.noProducts.style.display = 'none';
                } else {
                    this.productGrid.innerHTML = '';
                    this.noProducts.style.display = 'block';
                }

            })
            .catch(err => console.error('Error loading products:', err));
    }
}

if (!customElements.get('wls-product-listing')) {
    customElements.define('wls-product-listing', WLSProductListing);
}
